
  import {defineComponent} from "vue";
  import {SoundOutputPage} from "@/Interfaces/SoundOutputPage";
  import {mapState} from "vuex";
  import {OutputSources} from "@/Enums/OutputSources";
  import SharedFunctions from "@/Helpers/SharedFunctions";
  import * as Tone from 'tone'

  export default defineComponent({
    props: {
      hash: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        soundOutputPage: {} as SoundOutputPage,
        chosenOutput: null as string | null,
        headphones: OutputSources.HEADPHONES as OutputSources,
        computer: OutputSources.COMPUTER as OutputSources,
        canGoNextPage: true
      }
    },
    created() {
      if (!this.hash || this.hash === '') {
        window.location.href = "https://evollu.com"
      } else {
        let currentPageInfo = this.$store.state.generalFlowInfo.pages[this.currentPageIndex] as SoundOutputPage
        this.soundOutputPage.title = currentPageInfo.title
      }
    },
    methods: {
      async handleClick(output: OutputSources) {
        this.$store.commit('setOutput', output)
        await this.startTone()
        this.nextPage()
      },
      async startTone() {
        await Tone.context.resume()
        await Tone.start()
      },
      nextPage() {
        if (this.canGoNextPage) {
          SharedFunctions.nextPage(this.$router, this.$store, this.hash)
          this.canGoNextPage = false
        }
      },
    },
    computed: {
      ...mapState([
          'currentPageIndex'
      ])
    }
  })
